import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PfiFormData } from './PfiFormData';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { VsExpectedIwd, VsProformaService } from 'coadapi';

@Injectable({
  providedIn: 'root'
})
export class PfiService {
  private readonly storageKey = 'pfiValueSheetData';

  private pfiValueSheetSubject = new BehaviorSubject<any[]>([]);
  public pfiValueSheet$ = this.pfiValueSheetSubject.asObservable();

  private inlandCache = new Map<number, any[]>();

  constructor(
    private http: HttpClient,
    private proformaService: VsProformaService
  ) {
    const cachedData = localStorage.getItem(this.storageKey);
    if (cachedData) {
      this.pfiValueSheetSubject.next(JSON.parse(cachedData));
    } else {
      this.refreshCache().subscribe();
    }
  }

  private getPfiList(forceRefresh = false): Observable<any[]> {
    const requestOptions = forceRefresh
      ? {
        headers: new HttpHeaders({
          'Cache-Control': 'no-cache, no-store, max-age=0',
          Pragma: 'no-cache'
        }),
        transferCache: false
      }
      : {transferCache: false};

    return this.proformaService.getPVS('body', false, requestOptions)
      .pipe(
      tap(data => {
        this.pfiValueSheetSubject.next(data);
        localStorage.setItem(this.storageKey, JSON.stringify(data));
      }),
      catchError(error => {
        console.error('Error fetching PFI value sheets:', error);
        return of([]);
      })
    );
  }

  public refreshCache(): Observable<any[]> {
    localStorage.removeItem(this.storageKey);
    this.inlandCache.clear();

    return this.getPfiList(true);
  }

  public getPfiValueSheets(): Observable<any[]> {
    return this.pfiValueSheet$;
  }

  public getProformaById(proformaId: number): Observable<any> {
    return this.proformaService.getPVSdetails(proformaId);
  }

  public updatePfi(pfi: any): Observable<any> {
    return this.proformaService.updatePVS(pfi);
  }

  public addIwdCharge(iwd: VsExpectedIwd): Observable<VsExpectedIwd> {
    return this.proformaService.postIwdCharge(iwd);
  }

  public updateIwdCharge(iwd: VsExpectedIwd): Observable<VsExpectedIwd> {
    return this.proformaService.updateIwdCharge(iwd);
  }

  public getSplitInland(pfiId: number): Observable<any> {
    if (this.inlandCache.has(pfiId)) {
      return of(this.inlandCache.get(pfiId));
    }
    return this.proformaService.getSplitInland(pfiId).pipe(
      tap(data => this.inlandCache.set(pfiId, data))
    );
  }
}


